/**
 * External Imports
 */
import { FC } from 'react';
import { connect, useDispatch } from 'react-redux';

/**
 * Internal Imports
 */
import { RootState } from '../../../redux/store';
import { openModal, setModalType } from '../../../redux/actions';

/**
 * Style Imports
 */
import {
  StyledProvisioningBtn
  // TinySpinner
} from './ProvisioningBtn.styles';

interface IProvisioningBtnProps {
  modalState: boolean;
}

const ProvisioningBtn: FC<IProvisioningBtnProps> = ({ modalState }) => {
  const dispatch = useDispatch();

  const toggleModal = (mType: string) => {
    if (modalState === false) {
      dispatch(setModalType(mType));
      dispatch(openModal());
    }
  };

  return (
    <StyledProvisioningBtn
      id="Provision-Button"
      className="me-3"
      color="blue"
      kind="primary"
      size="small"
      style={{ '--button-padding': '10em' }}
      onClick={() => toggleModal('Provisioning')}
    >
      Provision User
    </StyledProvisioningBtn>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    modalState: state.ModalReducer.modal
  };
};

export default connect(mapReduxStateToProps)(ProvisioningBtn);
